import { DegreeInRad } from "project-constants/misc.constants";

export const toRadians = (degrees: number) => DegreeInRad * degrees;
